import Logo from '../../assets/logos/light/assegurados-horizontal-light.svg';
import FacebookIcon from '../../assets/icons/facebook.svg';
import InstagramIcon from '../../assets/icons/instagram.svg';
import TiktokIcon from '../../assets/icons/tiktok.svg';
import WhatsappIcon from '../../assets/icons/whatsapp.svg';
import VisaIcon from '../../assets/icons/visa.svg';
import MasterIcon from '../../assets/icons/master.svg';
import HiperIcon from '../../assets/icons/hiper.svg';
import EloIcon from '../../assets/icons/elo.svg';

import { Link } from 'react-router-dom';
import { COMPANY } from '../../config/legal/company.data';
import {
  Box,
  Container,
  Divider,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';

const Footer = () => {
  const theme = useTheme();
  const tyStyle = {
    color: `${theme.palette.primary.contrastText}`,
    fontSize: '0.8rem',
    textAlign: 'center',
    marginTop: '1rem',
  };
  const socialMedia = [
    {
      id: 'instagram',
      icon: InstagramIcon,
      link: 'https://www.instagram.com/assegurados.oficial/',
    },
    {
      id: 'facebook',
      icon: FacebookIcon,
      link: 'https://www.facebook.com/profile.php?id=100083402373891',
    },
    {
      id: 'whatsapp',
      icon: WhatsappIcon,
      link: 'https://api.whatsapp.com/send?phone=5543996823513',
    },
    {
      id: 'tiktok',
      icon: TiktokIcon,
    },
  ];
  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: '#020A23',
        padding: {
          xs: `${theme.spacingValues.large} ${theme.spacingValues.small}`,
          md: `${theme.spacingValues.large}`,
        },
      }}
    >
      <Container sx={{ margin: '0 auto' }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 4, md: 12 }}
          justifyContent="space-between"
          alignItems="flex-start"
        >
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
            }}
          >
            <img
              className="logo"
              src={Logo}
              alt="Logo"
              style={{ maxWidth: '100%', height: 'auto' }}
            />
            <Typography sx={tyStyle}>Contato:</Typography>
            <Typography sx={tyStyle}>WhatsApp: (43) 99682 3513</Typography>
            <Typography sx={tyStyle}>Email: adm@assegurados.com</Typography>
          </Box>
          <Stack
            direction="column"
            justifyContent="space-between"
            alignItems="flex-start"
          >
            <Typography
              sx={{
                ...tyStyle,
                fontWeight: 'bold',
              }}
            >
              Seguradoras
            </Typography>
            <Link
              className="option"
              to="/seguradoras/assist-card"
              style={{ textDecoration: 'none' }}
            >
              <Typography sx={tyStyle}>Assist Card</Typography>
            </Link>
            <Link
              className="option"
              to="/seguradoras/universal"
              style={{ textDecoration: 'none' }}
            >
              <Typography sx={tyStyle}>Universal Assistance</Typography>
            </Link>
            <Link
              className="option"
              to="/seguradoras/affinity"
              style={{ textDecoration: 'none' }}
            >
              <Typography sx={tyStyle}>Affinity</Typography>
            </Link>
          </Stack>
          <Stack
            direction="column"
            justifyContent="space-between"
            alignItems="flex-start"
          >
            <Typography
              sx={{
                ...tyStyle,
                fontWeight: 'bold',
              }}
            >
              Atendimento
            </Typography>
            <Link to="/sobre-nos" style={{ textDecoration: 'none' }}>
              <Typography sx={tyStyle}>Sobre nós</Typography>
            </Link>
            <Link to="/duvidas" style={{ textDecoration: 'none' }}>
              <Typography sx={tyStyle}>Dúvidas</Typography>
            </Link>
            <Link to="/blog" style={{ textDecoration: 'none' }}>
              <Typography sx={tyStyle}>Blog</Typography>
            </Link>
            <Link to="/termos-de-uso" style={{ textDecoration: 'none' }}>
              <Typography sx={tyStyle}>Termos de uso</Typography>
            </Link>
            <Link to="/politica-de-privacidade" style={{ textDecoration: 'none' }}>
              <Typography sx={tyStyle}>Política de privacidade</Typography>
            </Link>
          </Stack>
        </Stack>
        <Divider
          sx={{
            margin: '2rem 0',
            borderColor: theme.palette.primary.main,
          }}
        />
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems="flex-start"
        >
          <Stack
            direction="column"
            justifyContent="space-between"
            sx={{
              alignItems: { xs: 'center', md: 'flex-start' },
              width: { xs: '100%', md: 'auto' },
              order: { xs: 2, md: 1 },
            }}
          >
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems={'flex-start'}
            >
              {socialMedia.map((item) => {
                if (!!item.link)
                  return (
                    <a
                      key={item.id}
                      href={item.link}
                      target="_blank"
                      rel="noreferrer"
                      style={{ marginRight: '1rem' }}
                    >
                      <img key={item.id} src={item.icon} alt={item.id} />
                    </a>
                  );
                else return <img key={item.id} src={item.icon} alt={item.id} />;
              })}
            </Stack>
            <Typography sx={tyStyle}>
              Assegurados © {new Date().getFullYear()} – Todos os Direitos reservados
            </Typography>
            <Typography sx={{ ...tyStyle, fontSize: '0.75rem', opacity: 0.8 }}>
              {COMPANY.legalName} · CNPJ {COMPANY.cnpj}
            </Typography>
          </Stack>
          <Stack
            direction="column"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            sx={{
              order: { xs: 1, md: 2 },
              marginBottom: { xs: '1rem', md: 0 },
              alignItems: 'center',
              width: { xs: '100%', md: 'auto' },
            }}
          >
            <Typography sx={tyStyle}>Métodos de pagamento</Typography>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="flex-start"
              spacing={1}
            >
              <img alt="visaIcon" src={VisaIcon} />
              <img alt="masterIcon" src={MasterIcon} />
              <img alt="hiperIcon" src={HiperIcon} />
              <img alt="eloIcon" src={EloIcon} />
            </Stack>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;
